import { HappinessIndex } from 'components/employee-analytics/analytic-item/HappinessIndex'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { API_EMPLOYEE_ANALYTICS } from 'services/apiEmployeeAnalytics'
import { useFetch } from 'services/useFetch'
import { getYears } from 'utils/utils'

const INITIAL_FILTER = {
    start_year: moment().get('year') - 1,
    end_year: moment().get('year'),
    department_names: [],
}

const HappinessIndexContainer = () => {
    const { fetching: getHappinessIndex, isLoading } = useFetch(API_EMPLOYEE_ANALYTICS.HAPPINESS_INDEX)
    const [rawData, setRawData] = useState([])
    const [happinessIndexData, setHappinessIndexData] = useState([])
    const [filter, setFilter] = useState(INITIAL_FILTER)
    const [checkedItem, setCheckedItem] = useState({
        company: true,
        pnc: true,
        finance: true,
    })

    const applyCheckedFilter = (data, checked) =>
        data.map((item) =>
            Object.fromEntries(
                Object.entries(item).filter(([key]) => {
                    if (key === 'period') return true
                    return checked[key] !== false
                }),
            ),
        )

    useEffect(() => {
        setHappinessIndexData(applyCheckedFilter(rawData, checkedItem))
    }, [rawData, checkedItem])

    useEffect(() => {
        ;(async () => {
            const happinessIndex = await getHappinessIndex(filter)
            const newData = happinessIndex?.data?.map((item) => ({
                period: `${moment(item?.start_period, 'YYYY-MM').format('M/YY')} - ${moment(item?.end_period, 'YYYY-MM').format('M/YY')}`,
                company: item?.company_happiness_index,
                pnc: item?.pnc_happiness_index,
                finance: item?.finance_happiness_index,
            }))

            setRawData(newData)
        })()
    }, [filter])

    const onChangeChecked = ({ name, checked }) => {
        setCheckedItem((prev) => ({ ...prev, [name]: checked }))
    }

    const styleBar = (key) => {
        switch (key) {
            case 'company':
                return '#0f4c5c'
            case 'pnc':
                return '#00b4d8'
            case 'finance':
                return '#97a2b6'
            default:
                return '#788192'
        }
    }

    const onSubmitFilter = (newFilter) => {
        if (JSON.stringify(filter) !== JSON.stringify(newFilter)) {
            setFilter(newFilter)
        }
    }

    const props = {
        data: happinessIndexData,
        styleBar,
        isLoading,
        filter,
        onSubmitFilter,
        years: getYears(2021),
        checkedItem,
        onChangeChecked,
    }

    return <HappinessIndex {...props} />
}

export default HappinessIndexContainer
